import React from 'react';

const CategoryTab = ({ category, active, onClick, count }) => (
  <button
    onClick={onClick}
    className={`px-4 py-2 rounded-lg text-sm transition-all duration-200 border
      ${active 
        ? 'bg-white/5 text-white border-gray-700' 
        : 'text-gray-500 border-transparent hover:text-white hover:border-gray-800'}`}
  >
    {category} ({count})
  </button>
);

export default CategoryTab;